export default __webpack_public_path__ + "static/media/drop.40c297e3.svg";